import React from 'react';
import ReactECharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

export const PieChart = ({
  label = ['A', 'B'],
  data = [
    { value: 10, name: 'A' },
    { value: 12, name: 'B' },
  ],
  width = '400px',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const option = {
    title: {
      text: 'Max runtime',
      left: 'center',
      top: '47%',
      textStyle: {
        color: isAdminRoute,
        fontSize: 16,
        fontWeight: 'bold',
      },
    },
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: '10',
      top: 'center',
      textStyle: {
        color: isAdminRoute,
        fontSize: 12,
      },
      data: label,
    },
    series: [
      {
        name: 'Runtime',
        type: 'pie',
        radius: ['40%', '70%'], // Donut style
        avoidLabelOverlap: false,
        right: 'auto',
        label: {
          show: false, // Tắt label mặc định
          position: 'center',
        },
        emphasis: {
          label: {
            show: false, // Tắt chữ hiển thị khi hover
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
    media: [
      {
        query: {},
        option: {
          legend: {
            right: 'center',
            bottom: 0,
            orient: 'horizontal', // horizontal layout of legend
            textStyle: {
              color: isAdminRoute,
            },
          },
        },
      },
    ],
  };
  return (
    <ReactECharts
      option={option}
      style={{ height: '300px', width }}
      onEvents={() => {}}
    />
  );
};
